import { Component } from '@angular/core';
import { DecimalPipe, NgFor, NgIf } from "@angular/common";
import { MatIconModule } from '@angular/material/icon';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { FonteNotaInterface } from '../../shared/rodape-fonte-nota/fonte-nota.interface';
import { RodapeFonteNotaComponent } from '../../shared/rodape-fonte-nota/rodape-fonte-nota.component';
import { MemoriaDeCalculoService, CondicaoQualidadeStateService, AcessoOfertaEducacionalStateService } from '../../services';
import { MemoriaDeCalculoRequestDto} from '../../dtos/memoria-calculo-dto'
import { MemoriaDeCalculoDto } from '../../dtos';
import { NumeroFuncionariosDto } from '../../dtos/numero-funcionarios.dto';
import { NumeroFuncionariosService } from '../../services/numero-funcionarios/numero-funcionarios.service';
import { AnosReferenciasService } from '../../services/anos-referencias/anos-referencias.service';
import { AnosReferenciasDto } from '../../dtos/anos-referencias.dto';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

interface ProjecaoNumeroFuncionariosPorFuncao {
  etapa: string;
  projecao: number;
}

interface NumeroFuncionariosPorFuncao {
  projecoes: ProjecaoNumeroFuncionariosPorFuncao[];
  totalNumeroFuncionarios: number;
  totalFuncionariosPorFuncao: number;
}

@Component({
  selector: 'app-numero-funcionarios-funcao',
  standalone: true,
  imports: [
    MatIconModule,
    TabelaComponent,
    NgFor,
    NgIf,
    RodapeFonteNotaComponent,
    DecimalPipe
  ],
  templateUrl: './numero-funcionarios-funcao.component.html',
  styleUrl: './numero-funcionarios-funcao.component.scss',
})
export class NumeroFuncionariosFuncaoComponent {
  dadosTabela: NumeroFuncionariosPorFuncao | undefined;
  anosReferencias: AnosReferenciasDto | null = null;
  anoCenso: number;
  anoPqr: number;

  cabecalhoTabela = [
    { titulo: 'Área de atuação', tamanho: '34%' },
    {
      titulo: 'Número de funcionários em 2025 <sup>(1)(2)</sup>',
      tamanho: '28%',
    },
    {
      titulo: 'Projeção do número necessário de funcionários',
      tamanho: '38%',
      subtitulos: ['2026'],
    },
  ];

  notasFonte: FonteNotaInterface[] = [
    {
      titulo: 'Fontes',
      conteudos: [
        {
          numero: 1,
          descricao:
            'Elaborado a partir dos microdados do Censo Escolar/INEP 2025',
        },
        {
          numero: 2,
          descricao:
            'O número de funcionários é obtido pela soma das variáveis que trazem a quantidade de funcionários por função (Administrativo; Bibliotecário; Serviços Gerais; Coordenador; Alimentação; Pedagogia; Secretário; Segurança; Monitores; Gestão)',
        },
      ],
    }
  ];

  numeroFuncionarios: NumeroFuncionariosDto | undefined;
  memoriaCalculoDto: MemoriaDeCalculoDto | undefined;

  constructor(
    private memoriaCalculoService: MemoriaDeCalculoService,
    private condicaoQualidadeStateService: CondicaoQualidadeStateService,
    private acessoEOfertaStateService: AcessoOfertaEducacionalStateService,
    private numeroFuncionariosService: NumeroFuncionariosService,
    private anosReferenciasService: AnosReferenciasService,
    private featureFlagService: FeatureFlagService
  ) {
    if (this.featureFlagService.funcionalidadeHabilitada('940-atualizacao-de-componentes-de-edicao-pqr')) {
      this.anosReferencias = this.anosReferenciasService.obterAnosReferenciasSnapshot();
    }
    this.anoCenso = this.anosReferencias?.anoCenso ?? 2025;
    this.anoPqr = this.anosReferencias?.anoPqr ?? 2026;
  }
  async ngOnInit() {
    this.memoriaCalculoDto = await this.memoriaCalculoService.recalcularMemoriaDeCalculo();

    this.numeroFuncionarios = await this.numeroFuncionariosService.obterPorLocalizacao();
    const ano = this.numeroFuncionarios?.ano ?? null;

    this.cabecalhoTabela[1].titulo = `Número de funcionários em ${ano ?? this.anoCenso} <sup>(1)(2)</sup>`;
    this.cabecalhoTabela[2].subtitulos = [String(this.anoPqr)];
    this.notasFonte[0].conteudos[0].descricao = `Elaborado a partir dos microdados do Censo Escolar/INEP ${this.anoCenso}`;

    this.preenchaInformacoesTabela();
  }

  preenchaInformacoesTabela() {
    this.dadosTabela = {
      projecoes: [],
      totalNumeroFuncionarios: this.numeroFuncionarios?.quantidade ?? 0,
      totalFuncionariosPorFuncao: this.memoriaCalculoDto?.resultadoEtapa18ProjecaoNumeroFuncionarios?.total ?? 0,
    };

    const funcionarios =
      this.memoriaCalculoDto?.resultadoEtapa18ProjecaoNumeroFuncionarios?.funcionariosPorFuncao ?? [];

    this.dadosTabela.projecoes = funcionarios
      .slice()
      .sort((a, b) => a.codTipoFuncao - b.codTipoFuncao)
      .map(projecao => ({
        etapa: projecao.nomeFuncao,
        projecao: projecao.quantidade,
      }));
  }
}
